<template>
  <L1 class="maps">
    <div class="titleHome" slot="slot_title">
      <select v-model="map" @change="setMapSelect">
        <option v-for="mp in maps" :key="`map-${mp.num}`" :value="mp._id">{{mp.name}}</option>
      </select>
      <button class="gotoedit" v-if="mapSelect&&mapSelect.type==='areas'" @click="$router.push({name: 'MapsEditor', params: {id: map}})" :style="{marginLeft: 'auto'}">編輯總覽</button>
      <button class="gotoedit" v-if="mapSelect&&mapSelect.type==='points'"  @click="$router.push({name: 'MapsEditor', params: {id: map}})" :style="{marginLeft: 'auto'}">編輯區域簡介</button>
    </div>
    <La0 :style="{gap: 0}" :ratio="'828px 1fr'">
    <div class="leftContent" :style="{height: '100%'}"  ref="currentMap" slot="left">
      <MapInteractionCSS v-if="mapSelect" :style="{height: '100%', width: '-webkit-fill-available'}"
      :value="value"
      @onChange="setState"
      @tap="pointSelect=pointSelect===$event ? null : $event">
        <img :src="`.${mapSelect.image}`" :onImageClick="onclick"/>
          <button v-for="(point, p) in points" :key="`point-${p}-${point.num}`" :id="point._id"
          :style="[{
            transform: `translate(-50%, -100%) scale(${(pointSelect===point._id?1.3:1)/value.scale})`,
            top: `${point.coordinates[1]}px`, left: `${point.coordinates[0]}px`},
            mapSelect.type==='points'&&point.category&&categories.find(e => e.category===point.category) ? {
                backgroundImage: pointSelect&&(point._id === pointSelect)
                ? `url(.${categories.find(e => e.category===point.category)?.focus})`
                :`url(.${categories.find(e => e.category===point.category)?.regular})`
              }:{}]"
            :class="[mapSelect.type==='areas'?'btnCurrentArea':'btnL', pointSelect===point._id?'current':'']"
            >{{mapSelect.type==='areas' ? point.name : ''}}</button>
      </MapInteractionCSS>
    </div>
    <div class="rightTop" :style="{height: '60px', border:'none'}">
      <a href="./webapi/tourGuide/qrcode" :style="{marginRight: 'auto', width: '150px', height:'40px', textDecoration:'none', color: '#FFFFFF', background: 'var(--color-checked)',
      alignItems: 'center', display: 'flex', justifyContent: 'center', letterSpacing: '.1em', borderRadius: '3px', marginLeft: '43px'}">下載QR-CODE</a>
      <div v-if="editOrder" class="btnRight">
        <button class="cancel" @click="editOrder=false">取消</button>
        <button class="save" @click="saveOrder">儲存</button>
      </div>
      <div v-else class="btnRight">
        <button class="editOrder" @click="editOrder=true">編輯排序</button>
      </div>
    </div>
    <div class="rightContent" :style="{margin: 0, padding: '0 22px 0 0' }">
      <!-- <tableComponent @itemsUpdate="itemSorted=$event.map(e => e._id)" border="none" :selected="(item) => { return pointSelect&&(item._id === pointSelect) }" :sortable="false" sortkey="index" asc="asc" :items="points" :head="header"/> -->
        <TableDrag :style="{width: '100%'}" :rows="points" :draggable="editOrder" @sort="itemSorted=$event.map(e => e._id)">
          <template slot="slot_head">
            <th>標點</th>
            <th v-if="mapSelect&&mapSelect.type==='points'">類別</th>
            <th :style="{textAlign: 'start', width: 'inherit'}">地點名稱</th>
            <th v-if="mapSelect&&mapSelect.type==='points'">不顯示</th>
            <th v-if="production" :style="{textAlign: 'start', width: '200px'}">語言顯示</th>
            <th>基本編輯</th>
            <th>編輯內文</th>
            <th>刪除</th>
          </template>
          <tr slot-scope="{item, index}"
          :style="{borderBottom: '1px solid var(--color-border)', height: '75px', display: 'table-row'}"
          :class="pointSelect&&(item._id === pointSelect)?'selected':''"
          @click="pointSelect=pointSelect&&pointSelect===item._id?null:item._id;">
            <td>{{item.num}}</td>
            <td v-if="mapSelect&&mapSelect.type==='points'"><button :class="item.category||''" class="btnL" :style="[{
              position: 'relative',
              marginTop: '10px',
              backgroundPosition: 'center'
            }, item.category&&categories.find(e => e.category===item.category) ? {
              backgroundImage: pointSelect&&(item._id === pointSelect) ? `url(.${categories.find(e => e.category===item.category).focus})` : `url(.${categories.find(e => e.category===item.category).regular})`
            }:{}]" disabled></button></td>
            <td :style="{textAlign: 'start'}">{{item.name}}</td>
            <th v-if="mapSelect&&mapSelect.type==='points'">
              <button :id="`actived-${item._id}`" class="actived" :class="item.actived ? 'checked' : ''" @click.stop="activeFn(item._id, 'actived', !item.actived, index)"/>
            </th>
            <td v-if="production"><div :style="{alignItems: 'start', display: 'flex', gap: '15px'}">
              <Btn :class="item.tw? 'active' : ''" text="中" @click="activeFn(item._id, 'tw', !item.tw, index)"/>
              <Btn :class="item.en? 'active' : ''" text="英" @click="activeFn(item._id, 'en', !item.en, index)"/>
              <Btn :class="item.ja? 'active' : ''" text="日" @click="activeFn(item._id, 'ja', !item.ja, index)"/>
            </div></td>
            <td><button class="editBtn" @click.stop="$router.push({ name: 'MapsEditor', params: { id: mapSelect._id }, query: { id: item._id } })"/></td>
            <td><button class="editBtn2" @click.stop="$router.push({ name: 'MapsEditor', params: { id: mapSelect._id }, query: { id: item._id, editContent: true } })"/></td>
            <td><button class="deleteBtn" @click.stop="deletePoint(item)"/></td>
          </tr>
        </TableDrag>
    </div>
    </La0>
  </L1>
</template>

<script>
import L1 from '../../components/layout/L1.vue'
import La0 from '../../components/layout/La1.vue'
import Btn from '../../components/btn/btnsCircle.vue'
import TableDrag from '../../components/tables/t2_drag.vue'
// import tableComponent from '../components/tableFn.vue'
import MapInteractionCSS from '../../components/mapInteraction.vue'
import { getapi, postapi, deleteapi } from '../../store/fetch'
const VUE_APP_MAPLANG = JSON.parse(process.env.VUE_APP_MAPLANG)
export default {
  components: {
    // tableComponent,
    MapInteractionCSS,
    TableDrag,
    Btn,
    L1,
    La0
  },
  watch: {
    // points () {
    //   if (this.focus && this.points) {
    //     const p = this.points.find(e => e._id === this.focus)
    //     if (p) {
    //       this.setFocus(p)
    //     }
    //   }
    // }
  },
  computed: {
    screen () {
      return {
        width: 840,
        height: window.screen.height - 200
      }
    },
    image () {
      if (this.mapSelect) {
        return {
          width: this.mapSelect.width,
          height: this.mapSelect.height
        }
      } else {
        return {
          width: this.screen.width,
          height: this.screen.height
        }
      }
    },
    points () {
      if (this.mapSelect) {
        return JSON.parse(JSON.stringify(this.mapSelect[this.mapSelect.type]))
      } else {
        return []
      }
    }
  },
  data () {
    return {
      production: VUE_APP_MAPLANG,
      categories: [],
      // areamap: [],
      itemSorted: [],
      pointSelect: null,
      edit: false,
      editOrder: false,
      editContent: false,
      defaultScale: 1,
      value: {
        scale: Math.min((window.screen.width / 2 - 80) / 1920, (window.screen.height - 200) / 1080),
        translation: {
          x: 0,
          y: 0
        }
      },
      map: null,
      maps: [],
      mapSelect: null,
      header: {
        num: {
          title: '標點',
          fn: (item) => {
            this.pointSelect = this.pointSelect === item._id ? null : item._id
          },
          headerStyle: {
            textAlign: 'center',
            width: '76px',
            paddingLeft: '25px',
            paddingRight: '15px'
          },
          bodyStyle: {
            textAlign: 'center',
            width: '55px',
            paddingLeft: '25px',
            paddingRight: '15px'
          }
        },
        name: {
          title: '地點名稱',
          fn: (item) => {
            this.pointSelect = this.pointSelect === item._id ? null : item._id
          },
          headerStyle: {
            textAlign: 'start',
            paddingInline: '9px'
          },
          bodyStyle: {
            textAlign: 'start',
            paddingInline: '9px'
          }
        },
        actived: {
          title: '不顯示',
          fn: async (item) => {

          },
          headerStyle: {
            textAlign: 'center',
            width: '100px',
            paddingInline: '9px'
          },
          bodyStyle: {
            textAlign: 'center',
            width: '100px',
            paddingInline: '9px'
          }
        },
        edit: {
          title: '基本編輯',
          fn: (item) => {
            this.$router.push({ name: 'MapsEditor', params: { id: this.mapSelect._id }, query: { id: item._id } })
          },
          headerStyle: {
            textAlign: 'center',
            width: '100px',
            paddingInline: '9px'
          },
          bodyStyle: {
            textAlign: 'center',
            width: '100px',
            paddingInline: '9px'
          }
        },
        editContent: {
          title: '編輯內文',
          fn: (item) => {
            this.$router.push({ name: 'MapsEditor', params: { id: this.mapSelect._id }, query: { id: item._id, editContent: true } })
          },
          headerStyle: {
            textAlign: 'center',
            width: '100px',
            paddingInline: '9px'
          },
          bodyStyle: {
            textAlign: 'center',
            width: '100px',
            paddingInline: '9px'
          }
        },
        deleteItem: {
          title: '刪除',
          fn: (item) => {
            this.deletePoint(item)
          },
          headerStyle: {
            textAlign: 'center',
            width: '58px',
            paddingLeft: '9px',
            paddingRight: '17px'
          },
          bodyStyle: {
            textAlign: 'center',
            width: '58px',
            paddingLeft: '9px',
            paddingRight: '17px'
          }
        }
      }
    }
  },
  methods: {
    async activeFn (_id, key, value, index) {
      const result = await postapi(`tourGuide/${this.mapSelect.type}/${_id}`, { [key]: value })
      console.log('active action', _id, key, value, index, this.mapSelect.type, result)
      this.mapSelect[this.mapSelect.type][index][key] = result[key]
    },
    setFocus (point) {
      this.value.scale = 1
      this.value.translation = {
        x: this.screen.width / 2 - (point.coordinates[0] / this.value.scale),
        y: -70 + this.screen.height / 2 - (point.coordinates[1] / this.value.scale)
      }
    },
    async deletePoint (point) {
      await deleteapi(`tourGuide/${this.mapSelect._id}/${point._id}`)
      this.getMapList()
    },
    async saveOrder () {
      await postapi(`tourGuide/${this.mapSelect._id}`, { [this.mapSelect.type]: this.itemSorted })
      this.points.sort((a, b) => this.itemSorted.indexOf(a._id) > this.itemSorted.indexOf(b._id) ? 1 : -1)
      this.editOrder = false
    },
    setMapSelect () {
      if (this.map !== this.$route.query.id) {
        this.$router.replace({ name: 'Maps', query: { id: this.map } })
      }
      this.$nextTick(() => {
        if (this.map) {
          // console.log(this.$refs.currentMap)
          // console.log(this.$refs.currentMap.clientWidth, this.$refs.currentMap.clientHeight)
          const map = this.maps.find(e => e._id === this.map)
          this.defaultScale = Math.min((this.$refs.currentMap.clientWidth - 78) * 2 / map.width, (this.$refs.currentMap.clientHeight - 78) * 2 / map.height)
          this.value.scale = this.defaultScale
          this.mapSelect = map
          // this.value.translation = {
          //   x: (this.$refs.currentMap.clientWidth + 78 - this.mapSelect.width * this.defaultScale / 1.5) / 2,
          //   y: (this.$refs.currentMap.clientHeight - 78 - this.mapSelect.height * this.defaultScale / 1.5) / 2
          // }
          this.value.translation = {
            x: 0,
            y: 0
          }
        } else {
          return null
        }
      })
    },
    async getMapList () {
      const data = await getapi('tourGuide/list')
      this.maps = data
      if (this.$route.query?.id) {
        this.map = this.$route.query.id
      } else {
        this.map = data.length > 0 ? data[0]._id : null
      }
      this.setMapSelect()
    },
    onclick (evt) {
      const coords = {
        x: evt.nativeEvent.layerX / this.value.scale - this.value.translation.x / this.value.scale,
        y: evt.nativeEvent.layerY / this.value.scale - this.value.translation.y / this.value.scale
      }
      this.point = coords
    },
    setState (evt) {
      // // console.log('setState', evt)
      const { scale, translation } = evt
      if (scale < this.defaultScale) {} else if (scale > 2) {} else {
        this.value = { scale, translation }
      }
    }
  },
  async created () {
    const categories = await getapi('selections/map_category')
    this.categories = categories // [{ category: null, focus: '/map/point_red.svg', regular: '/map/point_blue.svg', removeable: false }, ...categories]
    this.getMapList()
  }
}
</script>

<style lang="scss">
.maps {
  // display: grid;
  .La1_right {
    overflow-y: auto!important;
  }
  .editBtn, .editBtn2 {
    width: 35px;
    height: 35px;
    border: none;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
    background-color: transparent;
    background-image: url(/pen.svg);
    background-position: center;
    background-repeat: no-repeat;
    margin-block: 15.5px;
    border-radius: 50%;
    border: none;
    cursor: pointer;
  }
  .actived {
    width: 35px;
    height: 35px;
    border: none;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
    background-color: transparent;
    background-position: center;
    background-repeat: no-repeat;
    margin-block: 15.5px;
    border-radius: 3px;
    border: none;
    cursor: pointer;
    background-color: var(--color-border);
    mask-image: url(/visibility_off.svg);
    &.checked {
      background-color: var(--color-checked);
      mask-image: url(/visibility.svg);
    }
  }
  .editBtn {
    background-color: var(--color-checked);
  }
  .editBtn2 {
    background-color: var(--color-saveAs);
  }
  .deleteBtn {
    width: 35px;
    height: 35px;
    background-color: transparent;
    background-image: url(/delete.svg);
    background-position: center;
    background-repeat: no-repeat;
    margin-block: 15.5px;
    border: none;
    cursor: pointer;
  }
  .table {
    border-collapse: collapse;
  }
  .thead {
    background-color: var(--color-infobox);
    height: 40px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 40px;
    letter-spacing: 0.1em;
    color: var(--color-letter);
  }
  .tbody {
    overflow-y: auto;
  }
  .tr {
    height: 64px;
    border-bottom: 1px solid var(--color-border);
    line-height: 64px;
    &.selected {
      background-color: var(--color-infobox);
    }
  }
  .td {
    align-items: center;
    justify-content: center;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    letter-spacing: 0.1em;
    color: var(--color-letter);
  }
}
</style>
<style lang="scss" scoped>
.gotoedit {
  width: fit-content;
  padding-inline: 20px;
  height: 40px;
  border: none;
  border-radius: 3px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: #FFFFFF;
  background-color: var(--color-checked);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  &::before {
    content: url(/pen.svg);
    padding-top: 3px;
  }
}
.btnCurrent {
  position: absolute;
  width: 30px;
  height: 40px;
  background-color: transparent;
  z-index: 100;
  background-image: url(/point_yellow.svg);
  border: none;
  background-position: center bottom;
  background-size: contain;
}
.btnCurrentArea {
  position: absolute;
  width: fit-content;
  height: 30px;
  background-color: transparent;
  z-index: 100;
  border: none;
  background-color: var(--color-infobox);
  opacity: 0.8;
  padding-inline: 20px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  text-align: center;
  letter-spacing: 0.1em;
  color: var(--color-checked);
  border: 1px solid var(--color-checked);
}
.btnL {
  position: absolute;
  width: 27px;
  height: 27px;
  background-color: transparent;
  z-index: 100;
  background-image: url(/point_blue.svg);
  border: none;
  background-position: center bottom;
  background-size: contain;
  background-repeat: no-repeat;
  &.current {
    background-image: url(/point_red.svg);
  }
}
.leftContent {
  grid-area: leftC;
  box-sizing: border-box;
  width: 818px;
  border-right: 1px solid var(--color-border);
  padding: 39px;
  box-sizing: border-box;
}
.rightContent {
  box-sizing: border-box;
  grid-area: rightC;
  width: -webkit-fill-available;
  overflow-y: auto;
}
.rightTop {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  grid-area: rightTop;
  border-left: 1px solid var(--color-border);
  border-bottom: 1px solid var(--color-border);
}
// .maps {
//   display: grid;
//   grid-template-rows: 89px calc(100vh - 89px);
//   grid-template-columns: 818px 1fr;
//   // grid-template-areas: "title ." "leftC rightC";
//   grid-template-areas: "title title" "leftC rightC";
// }
.btnRight {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-right: 37px;
  &>button:not(.editOrder) {
    border: none;
    width: 80px;
    height: 40px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
    border-radius: 3px;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    &::before {
      content: '';
      display: inline-flex;
      align-items: center;
    }
    &.cancel {
      background-color: #C4C4C4;
      &::before {
        background-image: url(/cancel.svg);
        width: 23px;
        height: 23px;
        background-size: 23px;
      }
    }
    &.save {
      background-color: var(--color-confirm);
      &::before {
        background-image: url(/save.svg);
        width: 20px;
        height: 20px;
        background-size: 20px;
      }
    }
  }
}
.editOrder {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 40px;
  background: var(--color-checked);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  border: none;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: #FFFFFF;
  &::before {
    content: '';
    display: inline-flex;
    align-items: center;
    width: 20px;
    height: 20px;
    background-position: center;
    background-image: url(/sort.svg);
  }
}
.titleHome {
  box-sizing: border-box;
  grid-area: title;
  &>div {
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
  }
  select {
    box-sizing: border-box;
    width: 185px;
    height: 40px;
    border: 1px solid #C4C4C4;
    border-radius: 3px;
    text-indent: 12px;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: var(--color-checked);
  }
  height: 88px;
  display: flex;
  align-items: center;
  font-family: Noto Sans TC;
  gap: 20px;
  font-style: normal;
  font-weight: normal;
  border-bottom: 1px solid var(--color-border);
  font-size: 36px;
  line-height: 87px;
  /* identical to box height */
  letter-spacing: 0.15em;
  padding-inline: 18px 44px;
  text-indent: 13px;
  color: var(--color-pri);
  height: 89px;
  text-align: start;
}
</style>
